import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalStorageService } from "src/app/shared/services/angular-service/local-storage.service";
import { environment } from "src/environments/environment";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-probo-portfolio',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './probo-portfolio.component.html',
  styleUrl: './probo-portfolio.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None // Disable encapsulation
})
export class ProboPortfolioComponent implements OnInit {

  iframeAuthToken;
  sourceName;
  sanitizedUrl;
  url: string;

  constructor(
    private localStorageService: LocalStorageService,
    private sanitizer: DomSanitizer
  ) {
    this.iframeAuthToken = this.localStorageService.getItem('probo_token');
    this.sourceName = this.localStorageService.getItem('probo_source_name');
  }

  ngOnInit(): void {
    this.url = `${environment.PROBO_PORTFOLIO_URL}partner_auth_token=${encodeURIComponent(this.iframeAuthToken)}&source_name=${this.sourceName}`
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    console.log("Portfolio Url",this.sanitizedUrl)
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
